/**
 * Identificator getData after skipStore refill: last refill / element registry,
 * then pageFields. Swing fill then getData — not a stale page snapshot.
 */
export function extractIdentificatorRefillField(
  data: unknown,
  fieldName: string,
  registryName?: string,
): unknown {
  if (data == null) return undefined
  if (typeof data !== 'object' || Array.isArray(data)) return data
  const rec = data as Record<string, unknown>
  const keyed = rec[fieldName]
  if (keyed !== undefined && keyed !== null) return keyed
  const alt = registryName && registryName !== fieldName ? rec[registryName] : undefined
  if (alt !== undefined && alt !== null) return alt
  return undefined
}

export function resolveIdentificatorGetDataValue(sources: {
  refillValue?: unknown
  registryValue?: unknown
  pageFieldValue?: unknown
}): unknown {
  if (sources.refillValue !== undefined && sources.refillValue !== null) {
    return sources.refillValue
  }
  if (sources.registryValue !== undefined && sources.registryValue !== null) {
    return sources.registryValue
  }
  if (sources.pageFieldValue !== undefined && sources.pageFieldValue !== null) {
    return sources.pageFieldValue
  }
  return undefined
}
